import {
    StyleSheet
} from "react-native";
import type {
    BreadcrumbMeasuresConstantType,
    BreadcrumbCollapseConstantType,
    BreadcrumbMeasures,
    BreadcrumbSize
} from "./type";

export const BREADCRUMB_LINK_VARIANTS: Record<BreadcrumbSize, keyof NCoreUIKit.Typography> = {
    medium: "bodyMediumSize",
    small: "bodySmallSize",
    large: "bodyLargeSize"
};

export const BREADCRUMB_PAGE_VARIANTS: Record<BreadcrumbSize, keyof NCoreUIKit.Typography> = {
    medium: "labelMediumSize",
    small: "labelSmallSize",
    large: "labelLargeSize"
};

export const BREADCRUMB_ICON_SIZES: Record<BreadcrumbSize, keyof NCoreUIKit.IconSizes> = {
    medium: "medium",
    small: "small",
    large: "large"
};

export const getBreadcrumbMeasures = ({
    typography,
    iconSizes,
    spaces,
    size
}: BreadcrumbMeasuresConstantType): BreadcrumbMeasures => {
    const pageVariant = BREADCRUMB_PAGE_VARIANTS[size];

    const lineHeight = typography[pageVariant].lineHeight;

    return {
        iconSize: iconSizes[BREADCRUMB_ICON_SIZES[size]],
        boxHeight: lineHeight + spaces.spacingXs * 2,
        linkVariant: BREADCRUMB_LINK_VARIANTS[size],
        pageVariant,
        lineHeight
    };
};

export const getBreadcrumbIsCollapsed = ({
    itemsBeforeCollapse,
    itemsAfterCollapse,
    collapseBehaviour,
    compactBehaviour,
    entryCount,
    isOverflow,
    isCompact,
    maxItems
}: BreadcrumbCollapseConstantType): boolean => {
    if(collapseBehaviour === "never" || entryCount <= itemsBeforeCollapse + itemsAfterCollapse) {
        return false;
    }

    if(collapseBehaviour === "always") {
        return true;
    }

    if(isCompact && compactBehaviour === "collapse") {
        return true;
    }

    return entryCount > maxItems || isOverflow;
};

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 1
    }
});

export default stylesheet;
